import { environment } from '../environments/environment';

const api = {
  API: `${environment.backendlessAPI}/whl/v2/orders`,
};

export class AppConstants {
  public static get(prop: keyof typeof api) {
    return api[prop];
  }
}
